/**
 * object 去掉空值
 * @param obj 处理对象
 * @param filters 数据
 * @returns {{}}
 */
export default function cutObjectEmptyProperty (obj = {}, filters = [null, undefined, '']) {
  Object.keys(obj).forEach(k => {
    if (filters.includes?.(obj[k])) {
      delete obj[k]
    }
  })
  return obj
}
